<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
      action-buttons-name="TransferenciasJugadoresActionButtons" filter
      search-text="Buscar nombre de jugador" :search="search" toolbar toolbar-title="Jugadores cedidos a préstamo" :borderRadius="true" :toolBarNotAbsolute="true">
      <slot slot="toolbar-table"></slot>

    </DataTable>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {

  components: {
    DataTable
  },

  data () {
    return {
      path: 'cedidos-contracts',
      filterPath: 'filters/cedidos-contracts',
      search: null,
      searchText: 'Buscar jugador'
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Club cedente', value: 'clubFrom', filterField: true },
        { text: 'Jugador', value: 'player' },
        { text: 'Club cesionario', value: 'clubTo', filterField: true },
        { text: 'Estado', value: 'status', filterField: true },
        { text: 'Inicio contrato', value: 'startDate' },
        { text: 'Fin contrato', value: 'endDate' },
        { text: 'Fecha de cierre de contrato', value: 'closeDate' },
        { text: 'Desde inicio de contrato ', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta inicio de contrato', value: 'toDate', sortable: false, align: 'right', dateFilterField: true, visible: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = ['clubFrom', 'player', 'clubTo', 'status', 'startDate', 'endDate', 'closeDate']
      return properties
    }
  },

  methods: {

  }
}
</script>
